
import React, {Component} from 'react';
import ReactDOM, {render} from 'react-dom';
import url from 'c-url';
import lang from '../lang/index';
import native from 'c-up-native';

class Result extends Component {

    componentWillMount() {
        document.title = lang.template('支付结果')
    }

    back() {

        const resultCode = url.query('result_code');

        if( window.self === window.top ) {

            let pl = native.getPlatform();
            let backurl = url.query('backurl');

            if (pl == 'uplive') {
                native.reportPayResult({
                    success: resultCode != 'FAIL'
                });

                // 延迟一定时间等待reportPayResult完成，然后跳转到热门列表
                setTimeout(() => {
                    native.goHotList();
                }, 300);
            } else {
                if (backurl) {

                    location.replace(backurl);

                } else {
                    let _url = location.href.replace(location.search, '').replace(location.hash, '');
                    location.href = url.addParam(_url, {
                        env: url.query('env'),
                        channel: url.query('channel'),
                        lang: url.query('lang'),
                        upcode: url.query('upcode')
                    });
                }
            }
        } else {
            parent.postMessage(resultCode, '*');
        }
    }
    
    render() {

        let resultCode = url.query('result_code');
        let status, txt;

        switch (resultCode) {
            case 'FAIL':
                status = lang.template('错误');
                txt = (
                    <div className="txt">{url.query('err_code_des')}</div>
                );
                break;
            case 'SUCCESS':
                status = lang.template('购买成功');
                break;
            case 'PAYING': 
                status = lang.template('交易中');
                let errCodeDesc = url.query('err_code_des');
                
                if (errCodeDesc) {
                    txt = (
                        <div className="txt">{decodeURIComponent(errCodeDesc)}</div>
                    );
                }
                break;
            default:
                break;
        }

        return (
            <div className="result">
                <div className="goodinfo">
                    <ul>
                        <li><em>{lang.template('商品')}:</em>{url.query('product_name')}</li>
                        <li><em>{lang.template('价格')}:</em>{url.query('money')} {url.query('currency')}</li>
                        <li><em>{lang.template('信息描述')}:</em>{url.query('product_desc')}</li>
                    </ul>

                </div>
                <div className="status">
                    <h3>{status}</h3>
                    {txt}
                </div>
                <button className="back" onClick={this.back}>{lang.template('返回')}</button>
            </div>
        );
    }
}

export default Result;




// WEBPACK FOOTER //
// ./js/result/index.js